import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import instance from "../../../config/Config";

const initialState = {
    loading: false,
    response: null,
    error: null,
};



//GET PAYMENT LIST
export const getAllPaymentList = createAsyncThunk(
    "getAllPaymentList",
    async (body, { rejectWithValue }) => {
        try {

            const response = instance.get(
                `crm/payment/get-global-payment-list?page=${body?.page}&search=${body?.search}&from=${body?.from}&to=${body?.to}&status=${body?.status}`
            );

            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);
export const AllPaymentSlice = createSlice({
    name: "AllPaymentSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getAllPaymentList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getAllPaymentList.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action?.payload;
        });

        builder.addCase(getAllPaymentList.rejected, (state, action) => {
            state.loading = false;
        });
    },
});
export default AllPaymentSlice.reducer;
